import {
    INVALID_ORDERS_COUNT_UPDATED,
    FETCHING_INVALID_ORDERS,
    INVALID_ORDERS_UPDATED,
    START_INVALID_ORDER_EDIT,
    END_INVALID_ORDER_EDIT,
} from './order.actionsTypes';

const initialState = {
    orders: [],
    total: 0,
    loading: false,
    editing: false,
    draft: null,
}

export default function invalidOrders(state = initialState, action) {
    switch (action.type) {
        case INVALID_ORDERS_COUNT_UPDATED:
            return {
                ...state,
                total: action.payload
            };
        case FETCHING_INVALID_ORDERS:
            return {
                ...state,
                loading: true
            }
        case INVALID_ORDERS_UPDATED:
            return {
                ...state,
                orders: action.payload,
                loading: false,
                total: action.payload.length
            };
        case START_INVALID_ORDER_EDIT:
            return {
                ...state,
                draft: state.orders.find(order => order.id === action.payload) || {},
                editing: true
            };
        case END_INVALID_ORDER_EDIT:
            return {
                ...state,
                draft: null,
                editing: false
            };
        default:
            return state;
    }
}
